const indexItems = [
  { label: '动作冒险', count: '2,340部', icon: 'ri-sword-line', color: 'primary' },
  { label: '科幻奇幻', count: '1,856部', icon: 'ri-rocket-line', color: 'accent' },
  { label: '悬疑惊悚', count: '1,520部', icon: 'ri-moon-line', color: 'secondary' },
  { label: '喜剧搞笑', count: '2,108部', icon: 'ri-emotion-laugh-line', color: 'primary' },
  { label: '爱情浪漫', count: '1,672部', icon: 'ri-heart-line', color: 'accent' },
  { label: '动画动漫', count: '1,940部', icon: 'ri-magic-line', color: 'secondary' },
  { label: '纪录写实', count: '980部', icon: 'ri-camera-line', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">电影索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          按类型快速浏览，从动作大片到文艺小众，总有一部适合你
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group text-center"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl mx-auto mb-3 ${
                item.color === 'accent' ? 'bg-accent-500/15' :
                item.color === 'secondary' ? 'bg-secondary-500/15' :
                'bg-primary-500/15'
              }`}>
                <i className={`${item.icon} text-xl ${
                  item.color === 'accent' ? 'text-accent-400' :
                  item.color === 'secondary' ? 'text-secondary-400' :
                  'text-primary-400'
                }`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-1">{item.label}</h3>
              <span className="text-xs text-foreground-600">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}